import { createTheme } from "@mui/material/styles";
import { green, teal, lime, lightBlue, lightGreen } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#757ce8",
      main: "#3f50b5",
      dark: "#002884",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ff6659",
      main: "#d32f2f",
      dark: "#9a0007",
      contrastText: "#ffffff",
    },
    info: {
      main: "#7e57c2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"quicksand", "Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

export const recommendationTheme = createTheme({
  palette: {
    primary: {
      light: lightBlue[300],
      main: lightBlue[500],
      dark: lightBlue[700],
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ff6659",
      main: "#d32f2f",
      dark: "#9a0007",
      contrastText: "#ffffff",
    },
    info: {
      main: "#7e57c2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"quicksand","Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
export const reportTheme = createTheme({
  palette: {
    primary: {
      light: teal[300],
      main: teal[500],
      dark: teal[700],
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ff6659",
      main: "#d32f2f",
      dark: "#9a0007",
      contrastText: "#ffffff",
    },
    info: {
      main: "#7e57c2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"quicksand" ,"Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
export const categoryTheme = createTheme({
  palette: {
    primary: {
      light: green[300],
      main: green[500],
      dark: green[700],
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ff6659",
      main: "#d32f2f",
      dark: "#9a0007",
      contrastText: "#ffffff",
    },
    info: {
      main: "#7e57c2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"quicksand","Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
export const scalesTheme = createTheme({
  palette: {
    primary: {
      light: lime[500],
      main: lime[700],
      dark: lime[900],
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ff6659",
      main: "#d32f2f",
      dark: "#9a0007",
      contrastText: "#ffffff",
    },
    info: {
      main: "#7e57c2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"quicksand
","Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
export const questionsTheme = createTheme({
  palette: {
    primary: {
      light: lightGreen[300],
      main: lightGreen[500],
      dark: lightGreen[700],
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ff6659",
      main: "#d32f2f",
      dark: "#9a0007",
      contrastText: "#ffffff",
    },
    info: {
      main: "#7e57c2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily: `"quicksand","Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
